import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';

export const UserDashboardPostAListingPageLoadable = clientOnlyLazy({
  loader: () => import('./UserDashboardPostAListingPage.dynamic'),
});
